import React from "react";
import closeIcon from "../../assets/cross.svg";

const ActivateSchoolModal = ({ onClose, onConfirm }) => {
  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex justify-center items-center">
      <div className="w-[500px] bg-white rounded-[20px] overflow-hidden font-['Manrope']">
        {/* Header */}
        <div className="p-6 bg-gradient-to-br from-white to-blue-100 border-b border-blue-100 flex justify-between items-center">
          <h2 className="text-[18px] font-bold text-gray-900">
            Activate School Access?
          </h2>
          <button onClick={onClose} className="p-1">
            <img src={closeIcon} alt="Close" className="w-5 h-5" />
          </button>
        </div>

        {/* Body */}
        <div className="px-6 pb-6 pt-6 flex flex-col gap-8">
          <div className="text-[16px] leading-normal">
            <span className="text-gray-500 font-medium">
              Are you sure you want to reactivate access for this school?{" "}
            </span>
            <span className="text-gray-900 font-bold">
              This will restore access for the administrator and all associated students.
            </span>
            <br />
            <br />
            <span className="text-gray-500 font-medium">
              You can deactivate access again later.
            </span>
          </div>

          {/* Footer Buttons */}
          <div className="flex justify-end gap-2">
            <button
              onClick={onClose}
              className="h-11 px-4 py-1.5 text-[16px] font-medium text-gray-900 border border-blue-500 rounded-lg hover:bg-gray-50 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={onConfirm}
              className="h-11 px-4 py-1.5 text-[16px] font-medium text-white bg-blue-500 rounded-lg hover:bg-blue-600 transition-colors"
            >
              Activate
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ActivateSchoolModal;